var common = require("../../utiles/common.js")
var service = require("../../utiles/service.js")

module.exports = {
    register: function () {
        document.createElement('account-apply')
        ko.components.register('account-apply', {
            viewModel: function (params) {
                var $this = this;
                $this.isdisplay = ko.observable(false);
                $this.type = ko.observable("tobe");
                $this.listApp = service.workflow.listApp();
                $this.getDown = function(){
                    if($this.isdisplay()){
                        $this.isdisplay(false)
                    }else{
                        $this.isdisplay(true)
                    }
                }
                $this.selectApp = function(appId,label){
                    common.redirectTo("/#/application/" + appId + '/' +label);
                }
                //切换条件
                $this.switchType = function(type){
                    $this.type(type);
                }
            },
            template: require("./template/AccountApply.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/workflow/AccountApply.js
// module id = 176
// module chunks = 0